import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { UserService } from 'src/app/core/services/user/user.service';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: false
})
export class NotificationsComponent implements OnInit {
  currentUser: any;
  value: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.currentUser = this.userService.getCurrentUser();
    this.value = this.currentUser.user.profile.can_receive_email_notifications;
  }

  codeValueChanged(event) {
    let value = event.value;
    const userId = this.userService.userId;
    let data = {
      can_receive_email_notifications: value
    }
    this.authenticationService.updateUserData(userId, data).subscribe(
      res => {
        console.log(res);
        this.currentUser["user"] = res;
        this.userService.setCurrentUser(this.currentUser);
      }
    )
  }

}
